import {Routes} from '@angular/router';
import {WholesaleposManagementComponent} from './wholesalepos.management.component';
import {equityManagementRoutes} from './equity-management/equity.management.routes';
import {memberManagementRoutes} from './member-management/member-management.routes';
import {rollManagementRoutes} from './roll-management/roll.management.routes';
import {prizeManagementRoutes} from './prize-management/prize.management.routes';
import {cashManagementRoutes} from './cash-management/cash.management.routes';
import {giftManagementRoutes} from "./gift-management/gift-management-routes";
import {releaseManagementRoutes} from "./release-management/release-management-routes";
import {orderManagementRoutes} from "./order-management/order-management-routes";
import {acceptManagementRoutes} from "./accept-management/accept-management-routes";
import {returngoodsManagementRoutes} from "./returngoods-management/returngoods-management-routes";
import {returnmoneyManagementRoutes} from "./returnmoney-management/returnmoney-management-routes";
import {afterserviceManagementRoutes} from "./afterservice-management/afterservice-management-routes";
import {shipmentManagementRoutes} from "./shipment-management/shipment-management-routes";
import {wholesaleposRecommendationRoutes} from "./wholesalepos-recommendation/wholesalepos-recommendation.routes";

export const wholesaleposManagementRoutes: Routes = [
  {
    path: 'wholesalepos.management',
    component: WholesaleposManagementComponent,
    data: { title: '批发收银后台管理' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./index/index.component').then(m => m.IndexComponent),
        data: { title: '首页' },
      },
      {
        path: 'categoryManagement',
        loadComponent: () => import('./category-management/category-management.component').then(m => m.CategoryManagementComponent),
        data: { title: '商店品类上架' },
      },
      {
        path: 'releasepriceManagement',
        loadComponent: () => import('./releaseprice-management/releaseprice-management.component').then(m => m.ReleasepriceManagementComponent),
        data: { title: '商品价格管理' },
      },
      {
        path: 'shopManagement',
        loadComponent: () => import('./shop-management/shop-management.component').then(m => m.ShopManagementComponent),
        data: { title: '商店管理' },
      },
      {
        path: 'shopgrantManagement',
        loadComponent: () => import('./shopgrant-management/shopgrant.management.component').then(m => m.ShopgrantManagementComponent),
        data: { title: '店铺授权' },
      },
      {
        path: 'releaseIntegrateManagement',
        loadComponent: () => import('./release-integrate-management/release-integrate-management.component').then(m => m.ReleaseIntegrateManagementComponent),
        data: {title: "商品积分管理"},
      },
      {
        path: 'integrateMoneyManagement',
        loadComponent: () => import('./integrate-money-management/integrate-money-management.component').then(m => m.IntegrateMoneyManagementComponent),
        data: {title: "积分现金管理"},
      },
      {
        path: 'bindGiftManagement',
        loadComponent: () => import('./bind-gift-management/bind-gift-management.component').then(m => m.BindGiftManagementComponent),
        data: { title: '绑定送礼品' },
      },
      {
        path: 'soldOutSkuManagement',
        loadComponent: () => import('./soldoutsku-management/soldoutsku-management.component').then(m => m.SoldoutskuManagementComponent),
        data: { title: '售罄商品管理' },
      },
      {
        path: 'shedulingManagement',
        loadComponent: () => import('./sheduling.management/sheduling.management.component').then(m => m.ShedulingManagementComponent),
        data: { title: '系统调度管理' },
      },
      {
        path: 'jobManagement',
        data: { title: '调度任务管理' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./job.management/job.management.component').then(m => m.JobManagementComponent),
            data: { title: '系统调度管理' },
          },
          {
            path: 'jobTriggerManagement/:jobName',
            loadComponent: () => import('./job.management/job.trigger.management/job.trigger.management.component')
              .then(m => m.JobTriggerManagementComponent),
            data: { title: '调度作业管理' },
          },
        ]
      },
      {
        path: 'userWholesaleposManagement',
        loadComponent: () => import('./user-wholesalepos-management/user-wholesalepos-management.component').then(m => m.UserWholesaleposManagementComponent),
        data: {title: '收银员管理'},
      },
      {
        path: 'userWholesaleposManagerManagement',
        loadComponent: () => import('./user-wholesaleposmanager-management/user-wholesaleposmanager-management.component').then(m => m.UserWholesaleposmanagerManagementComponent),
        data: {title: '门店管理员'},
      },
      {
        path: 'wholeSalePosFrontResourcesAuthorization/:accountId',
        loadComponent: () => import('./user-wholesalepos-management/whole-sale-pos-front-resources-authorization/whole-sale-pos-front-resources-authorization.component').then(m => m.WholeSalePosFrontResourcesAuthorizationComponent),
        data: {title: '批发门店收银员资源授权'},
      },
      {
        path: 'wholeSalePosBackendResourcesAuthorization/:accountId',
        loadComponent: () => import('./user-wholesaleposmanager-management/whole-sale-pos-backend-resources-authorization/whole-sale-pos-backend-resources-authorization.component').then(m => m.WholeSalePosBackendResourcesAuthorizationComponent),
        data: {title: '批发门店管理员资源授权'},
      },
      ...wholesaleposRecommendationRoutes,
      ...releaseManagementRoutes,
      ...giftManagementRoutes,
      ...equityManagementRoutes,
      ...memberManagementRoutes,
      ...rollManagementRoutes,
      ...prizeManagementRoutes,
      ...cashManagementRoutes,
      ...orderManagementRoutes,
      ...acceptManagementRoutes,
      ...returngoodsManagementRoutes,
      ...returnmoneyManagementRoutes,
      ...afterserviceManagementRoutes,
      ...shipmentManagementRoutes,
    ]
  },
];
